import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';
import ChampTexteLong from '../champs/ChampTexteLong';

function SectionCahierCharges({ contraintes, exigences, onAjouterContrainte, onSupprimerContrainte, onModifierContrainte, onAjouterExigence, onSupprimerExigence, onModifierExigence }) {
  return (
    <Carte titre="Cahier des charges technique" icone="⚙️">

      {/* ── Contraintes techniques ── */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--texte)' }}>
          Contraintes techniques
        </div>

        <div className="liste-dynamique">
          {contraintes.map((ct, idx) => (
            <div key={ct.id} className="liste-dynamique__item">
              <div className="liste-dynamique__item-entete">
                <span className="liste-dynamique__item-num">Contrainte {idx + 1}</span>
                <button
                  className="btn btn--danger btn--sm"
                  onClick={() => onSupprimerContrainte(ct.id)}
                >
                  ✕ Supprimer
                </button>
              </div>
              <div className="grille grille--2col">
                <ChampTexte
                  label="Nom"
                  valeur={ct.nom}
                  onChange={(_, val) => onModifierContrainte(ct.id, 'nom', val)}
                  nom="nom"
                  placeholder="ex : Compatibilité navigateurs"
                />
                <ChampTexteLong
                  label="Description"
                  valeur={ct.description}
                  onChange={(_, val) => onModifierContrainte(ct.id, 'description', val)}
                  nom="description"
                  placeholder="ex : L'application doit être compatible avec les navigateurs modernes"
                  lignes={2}
                  pleineLargeur
                />
              </div>
            </div>
          ))}
        </div>

        <button className="btn btn--fantome" style={{ marginTop: 8 }} onClick={onAjouterContrainte}>
          + Ajouter une contrainte
        </button>
      </div>

      {/* ── Exigences fonctionnelles ── */}
      <div style={{ borderTop: '1px solid var(--gris-bord)', paddingTop: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--texte)' }}>
          Exigences fonctionnelles
        </div>

        <div className="liste-dynamique">
          {exigences.map((ef, idx) => (
            <div key={ef.id} className="liste-dynamique__item">
              <div className="liste-dynamique__item-entete">
                <span className="liste-dynamique__item-num">EF_{idx + 1}</span>
                <button
                  className="btn btn--danger btn--sm"
                  onClick={() => onSupprimerExigence(ef.id)}
                >
                  ✕ Supprimer
                </button>
              </div>
              <div className="grille grille--2col">
                <ChampTexte
                  label="Nom"
                  valeur={ef.nom}
                  onChange={(_, val) => onModifierExigence(ef.id, 'nom', val)}
                  nom="nom"
                  placeholder="ex : Authentification utilisateur"
                />
                {/* <ChampTexte
                  label="Critère de validation"
                  valeur={ef.critere}
                  onChange={(_, val) => onModifierExigence(ef.id, 'critere', val)}
                  nom="critere"
                  placeholder="ex : L'utilisateur peut se connecter"
                />*/}
                <ChampTexteLong
                  label="Description"
                  valeur={ef.description}
                  onChange={(_, val) => onModifierExigence(ef.id, 'description', val)}
                  nom="description"
                  placeholder="Décrivez l'exigence fonctionnelle..."
                  lignes={2}
                  pleineLargeur
                />
              </div>
            </div>
          ))}
        </div>

        <button className="btn btn--fantome" style={{ marginTop: 8 }} onClick={onAjouterExigence}>
          + Ajouter une exigence fonctionnelle
        </button>
      </div>
    </Carte>
  );
}

export default SectionCahierCharges;
